jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});

document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.question p').forEach(function(p){
        p.style.display = 'none';
        p.style.height = '0';
        p.style.overflow = 'hidden';
    });

    document.querySelectorAll('.question button').forEach(function(btn){

        btn.addEventListener('click', function(e){

            e.preventDefault();

            const p = this.parentElement.querySelector('p');

            if (p.style.display === 'none') {
                p.style.display = 'block';
                p.style.height = 'auto';
                p.style.overflow = 'visible';
            } else {
                p.style.display = 'none';
                p.style.height = '0';
                p.style.overflow = 'hidden';
            }

        });

    });

});